import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
import { BUTTON__CONTENT_CLASS } from "../../Button/constants";
var SMALL_SIZE = 36;
var SMALL_HOVER_SIZE = SMALL_SIZE - 4;
var LARGE_SIZE = 44;
var LARGE_HOVER_SIZE = LARGE_SIZE - 4;
export var small = /*#__PURE__*/css(["width:", ";height:", ";&:active{transform:scale(", ");}"], pxToRem(SMALL_SIZE), pxToRem(SMALL_SIZE), SMALL_HOVER_SIZE / SMALL_SIZE);
export var large = /*#__PURE__*/css(["width:", ";height:", ";&:active{transform:scale(", ");}"], pxToRem(LARGE_SIZE), pxToRem(LARGE_SIZE), LARGE_HOVER_SIZE / LARGE_SIZE);
export var buttonOverrides = /*#__PURE__*/css(["border-radius:50%;border:none !important;padding:0;.", "{display:flex;justify-content:center;}&.focus-visible:focus{background-color:var(--neutral-white-base);}"], BUTTON__CONTENT_CLASS);